"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function LowPrice(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M22 22h-8.828L2.586 11.414A1.981 1.981 0 0 1 2 10c0-.533.209-1.034.586-1.412l6-6.002C8.962 2.208 9.465 2 10 2a1.98 1.98 0 0 1 1.414.588L22 13.172V22zm-2-2v-6L10 4l-6 6 10 10h6zM8.75 10.748c.034 1.176.8 2.134 1.075 2.441l-.62.621.685.686.617-.617.559.558-.617.618.69.689.618-.617c.95.95 2.878 1.936 4.629.185.45-.45.751-.929.865-1.127l-1.263-.937a2.369 2.369 0 0 1-.559.838c-1.035 1.035-2.089-.044-2.344-.287l1.172-1.172-.69-.692-1.171 1.172-.559-.558 1.172-1.172-.685-.686-1.165 1.164c-.43-.484-1.146-1.442-.248-2.34.296-.296.679-.473.817-.527l-.942-1.266c-.193.108-.67.39-1.046.766-.77.77-1.012 1.554-.99 2.26z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = LowPrice;
